import React from 'react'
import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Wrapper = styled.section`
  width: 100%;
  padding: 72px 0 84px;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  padding: 0 24px;

  @media (max-width: 900px) {
    padding: 0 20px;
  }
`;

const Title = styled(Typography)`
  color: #000;
  font-size: 56px;
  line-height: 1;
  font-family: "primary1" !important;
  text-align: center;
  position: relative;
  z-index: 2;
  margin-bottom: 62px;

  @media (max-width: 900px) {
    font-size: 48px;
    margin-bottom: 44px;
  }

  @media (max-width: 520px) {
    font-size: 36px;
    margin-bottom: 34px;
  }
`;

const FAQList = styled.div`
  width: 100%;
`;

const FAQItem = styled(Accordion)`
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
  border-radius: 4px !important;
  margin: 0 !important;
  transition: background 0.35s ease, box-shadow 0.35s ease !important;

  &::before {
    display: none;
  }

  &.Mui-expanded {
    background: #fff !important;
    box-shadow: 0 22px 34px rgba(0, 0, 0, 0.16) !important;
    margin-bottom: 18px !important;
    border-radius: 10px !important;
  }
`;

const FAQSummary = styled(AccordionSummary)`
  min-height: 58px !important;
  padding: 0 34px !important;
  transition: padding 0.35s ease, min-height 0.35s ease !important;

  &.Mui-expanded {
    min-height: 50px !important;
    padding-top: 22px !important;
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
  }

  /* Smooth icon rotation */
  .MuiAccordionSummary-expandIconWrapper {
    color: #000;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  @media (max-width: 520px) {
    padding: 0 20px !important;
  }
`;

const Question = styled(Typography)`
  color: #000;
  font-size: 24px;
  line-height: 1.25;
  font-family: "primary1" !important;

  @media (max-width: 520px) {
    font-size: 16px;
  }
`;

const Answer = styled(AccordionDetails)`
  padding: 0 34px 28px !important;

  p {
    color: #494b52;
    font-size: 17px;
    margin-top: 12px;
    line-height: 1.35;
    max-width: 720px;
  }

  @media (max-width: 520px) {
    padding: 0 20px 22px !important;
  }
`;

const faqs = [
  {
    question: 'What is Zephyr?',
    answer: 'Zephyr is the first privacy focused Web3 browser built on Solana Chain. It launches with Auto Burn Sessions and is expanding into a complete privacy focused Web3 execution environment.',
  },
  {
    question: 'Is Zephyr a wallet?',
    answer: 'No. Zephyr is a Web3 browser designed to work alongside your existing wallets while providing a more private browsing experience.',
  },
  {
    question: 'Why does privacy matter in Web3?',
    answer: 'Every wallet connection, browser session, and decentralized application interaction can reveal information about your activity. Zephyr helps reduce unnecessary exposure by putting privacy at the browser level.',
  },
  {
    question: 'Which blockchain is Zephyr built on?',
    answer: 'Zephyr is built on Solana Chain and is designed to become the privacy gateway for its growing ecosystem.',
  },
];

const FAQ = () => {
  const [expanded, setExpanded] = React.useState('panel-0');

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Wrapper data-aos="fade-up" data-aos-duration="900" id='FAQ'>
      <Inner>
        <Title>FAQ</Title>
        <FAQList>
          {faqs.map((item, index) => {
            const panel = `panel-${index}`;

            return (
              <FAQItem
                key={item.question}
                expanded={expanded === panel}
                onChange={handleChange(panel)}
                disableGutters
                // ✅ This is the key — smooth expand/collapse duration + easing
                TransitionProps={{
                  timeout: 200,
                  easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
                }}
              >
                <FAQSummary expandIcon={<ExpandMoreIcon fontSize="medium" />}>
                  <Question>{item.question}</Question>
                </FAQSummary>
                <Answer>
                  <Typography>{item.answer}</Typography>
                </Answer>
              </FAQItem>
            );
          })}
        </FAQList>
      </Inner>
    </Wrapper>
  );
};

export default FAQ;